// extracted by mini-css-extract-plugin
export default {"switch":"styles_switch__4C2KO","switchItem":"styles_switchItem__5LnMB","activeSwitchItem":"styles_activeSwitchItem__v8+Er"};